import { Link } from "@tanstack/react-router";
import { EmptyState } from "@signet/ui";

export function NotFound() {
  return (
    <div className="page">
      <EmptyState title="There's nothing here" body="The address may be wrong, or the page moved." actions={<Link to="/" className="secondary-button tiny">Go to Now</Link>} />
    </div>
  );
}

export function Forbidden() {
  return (
    <div className="page">
      <EmptyState title="You don't have access to this" body="Ask someone who manages people in Signet to give you access." actions={<Link to="/" className="secondary-button tiny">Go to Now</Link>} />
    </div>
  );
}
